import { TRPCClientError } from '@trpc/client';
import { isDroppableTrpcCode } from './trpcErrorCodes';

export function isBrowserTrpcClientError(error: unknown): boolean {
  return (
    error instanceof TRPCClientError &&
    isDroppableTrpcCode((error.data as { code?: unknown } | undefined)?.code)
  );
}
